import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Typography from '@mui/material/Typography';

import { EXPORT_CONFIG } from '@common/constants';

const UploadDialog = ({
  importFile = null,
  isOpen = false,
  onCancel = () => {},
  onConfirm = () => {},
  onFileChange = () => {}
}) => {
  const { t } = useTranslation();

  const fileInputRef = useRef(null);

  const importInfoMessages = t('import_info', {
    returnObjects: true,
    count: EXPORT_CONFIG.MAX_TEMPLATES_TO_EXPORT
  });

  const handleSelectFile = (e) => {
    onFileChange(e.target.files?.[0] || null);
  };

  return (
    <Dialog fullWidth maxWidth={'md'} open={isOpen}>
      <DialogTitle
        sx={{
          pb: 3
        }}
      >
        {t('upload_file')}
      </DialogTitle>

      <DialogContent>
        {importInfoMessages?.length > 0 && (
          <ul style={{ paddingLeft: 16 }}>
            {importInfoMessages.map((msg, index) => (
              <li key={index}>
                <Typography variant='body2' color='error'>
                  {msg}
                </Typography>
              </li>
            ))}
          </ul>
        )}

        <input
          type='file'
          accept='application/json'
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleSelectFile}
        />

        <Button
          variant='outlined'
          startIcon={<FileUploadIcon />}
          onClick={() => fileInputRef.current?.click()}
          fullWidth
        >
          {t('upload_json_button')}
        </Button>

        <Typography sx={{ mt: 2 }}>
          {importFile ? `${t('selected_file')} ` : t('no_file_selected')}
          <b>{importFile?.name || ''}</b>
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          variant='outlined'
          startIcon={<CancelIcon />}
          onClick={onCancel}
          color='error'
        >
          {t('cancel_button')}
        </Button>

        <Button
          variant='outlined'
          disabled={!importFile}
          startIcon={<SaveIcon />}
          onClick={onConfirm}
        >
          {t('save_button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDialog;
